import React from "react";
import "./AmazonMusicForArtists.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const AmazonMusicForArtists = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to Amazon Music",
    "Get your artist profile live",
    "Reach global listeners",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>

        <title>
          Get Your Music on Amazon Music | Amazon Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Upload your music to Amazon Music with FT Tunes distribution. Reach millions of listeners worldwide through Alexa devices, Prime Music and Amazon Music Unlimited."
        />

        <meta
          name="keywords"
          content="Amazon Music distribution, upload music to Amazon Music, Amazon Music for artists India, FT Tunes music distribution, distribute music worldwide"
        />

        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Get Your Music on Amazon Music | FT Tunes"
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://www.fttunes.com/get-your-music-on-amazon-music"
        />

      </Helmet>

      <div className="amazon-page">

        {/* HERO */}
        <section className="amazon-hero">
          <Container>

            <img
              src="/Images/amazon-music-logo.png"
              alt="Get Music on Amazon Music"
              className="amazon-logo"
            />

            <h1>Get Your Music on Amazon Music</h1>

            <p>
              Distribute your music on Amazon Music and reach millions of
              listeners worldwide through Alexa devices, smartphones,
              smart speakers, and streaming platforms. Release your singles,
              EPs, and albums globally while maintaining full ownership of
              your music. With FT Tunes music distribution, your tracks go
              live quickly on Amazon Music Unlimited and Prime Music,
              helping independent artists expand audiences and earn
              streaming royalties worldwide.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-amazon"></div>
        </section>

        {/* SHOWCASE */}
        <section className="amazon-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Listeners Across The World</h2>

                <p>
                  Make your music discoverable on Amazon Music, Alexa voice
                  search, Echo devices, and global streaming audiences.
                  Expand your reach and grow your fanbase internationally.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-music-on-amazon-music.png"
                  alt="Amazon Music distribution"
                  className="amazon-image"
                />
              </Col>

            </Row>
          </Container>
        </section>

        {/* STEPS */}
        <section className="amazon-steps">
          <Container>

            <h2 className="section-title">
              How It Works
            </h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* BENEFITS */}
        <section className="amazon-benefits">
          <Container>

            <h2 className="section-title">
              Built For Independent Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Global Reach</h5>
                  <p>Access millions of Amazon Music listeners worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Alexa Integration</h5>
                  <p>Your music playable via Alexa voice commands.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Streaming Revenue</h5>
                  <p>Earn royalties from streams and downloads.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>100% Ownership</h5>
                  <p>You keep full control of your music rights.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>

        {/* CTA */}
        <section className="amazon-cta">
          <Container>

            <h2>Start Growing on Amazon Music Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default AmazonMusicForArtists;